import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LocusRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class LocusRobotics_update_bot_configuration_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { Lookup: string, weightCapacity?: number, warehouse?: string, weightUOM?: string, length?: number, width?: number, height?: number, dimensionUOM?: string, type?: string, binCapacity?: number, volumeCapacity?: number }): Promise<void> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.Lookup)) {
      missingRequiredInParams.push('\'Lookup\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

